import axios from "axios";
import { useEffect, useState } from "react"

export default  function AuthRedirectZepto() {
    const [counter,setCounter] = useState(0);
    useEffect(() => {
        const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);
      const authCode = urlParams.get('code');
      const reimId = urlParams.get('id');
      console.log("Inside zepto auth");
        axios.post(`https://go.zeptopayments.com/oauth/token`,{
            grant_type: 'authorization_code',
            client_id: 'X8X7DAMvwlVx-1T1jmtKOOBp4a_sAAR-uYyHWzVDGPQ',
            client_secret: 'DfEhsQlxQ-aagv3dc0W-1E_Tgb8N0XzyS9x1zZg7c10',
            redirect_uri: 'https://portal.effiez.com.au/subfail2',
            code: authCode},{
            headers:{
                "Access-Control-Allow-Headers" : "Content-Type",
                "Access-Control-Allow-Origin": "*",
              'Content-Type': 'application/json',
               "Access-Control-Allow-Methods": "OPTIONS,POST,GET,PATCH"
            }
        } ,
        
        ).then((response) => {
            console.log(response);
            //localStorage.setItem('access_token', response.data.access_token);
            //localStorage.setItem('refresh_token', response.data.refresh_token);
            //window.location.href = '/dashboard';
           // setCounter(counter+1);
          });
    },[counter]);
    return (
        <div>
            <h1>AuthRedirectZepto{counter}</h1>
            <h1>AuthRedirectZepto{counter}</h1>
            <h1>AuthRedirectZepto{counter}</h1>
            <h1>AuthRedirectZepto{counter}</h1>
            <h1>AuthRedirectZepto{counter}</h1>
            <h1>AuthRedirectZepto{counter}</h1>
        </div>
    )

}